export const UTILITY_DUKE_ORDER_PREFIX = /^V.*:enterprise:/;
export const DUKE_CODE = 'duke-homeperks';
export const PGE_CODE = 'pge-homeperks';
